import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { Field } from 'redux-form';
import { Theme, colors } from 'hui/src/styled/theme';
import { ErrorText } from '../Field';

const QuestionLabel = styled.label`
  display: block;
  margin-top: 25px;
  font-weight: 600;
  margin-bottom: 15px;
`;

const AnswerLabel = styled.label`
  cursor: pointer;
  padding: 10px 15px;
  border: 1px solid ${colors.GREY};
  border-radius: 100px;
  background-color: ${Theme.snow};
  color: ${colors.MEDIUM_DARK_GREY};
  text-decoration: none;
  display: inline-block;
  font-size: 13px;
  ${props =>
    props.stacked &&
    css`
      display: block;
      width: 100%;
      font-size: 16px;
  }`};
`;

const RadioOption = styled.div`
  display: inline-block;
  margin: 0 5px 5px 0;
  ${props =>
    props.stacked &&
    css`
      display: block;
      width: 100%;
      font-size: 16px;
  }`};

  input[type='radio']:checked + label,
  input[type='radio']:active + label {
    background: ${Theme.primary};
    color: ${Theme.snow};
    border-color: ${Theme.primary};
  }
`;

export const Input = styled(Field)`
  display: none;
`;

const errorMessage = (
  { meta } // eslint-disable-line
) => (meta.error ? <ErrorText>{meta.error}</ErrorText> : null);

export default function RadioGroup({ options, name, label, stacked, onChange }) {
  return (
    <div>
      {label && (
        <QuestionLabel>
          <span>{label}</span>
        </QuestionLabel>
      )}
      {options.map(({ value, label }) => {
        const key = `${name}_${value}`;
        return (
          <RadioOption key={key} stacked={stacked}>
            <Input
              type="radio"
              name={name}
              id={key}
              value={`${value}`}
              component={({ input, ...rest }) => {
                return (
                  <input
                    name={name}
                    {...input}
                    {...rest}
                    onChange={value => {
                      input.onChange(value);
                      onChange(value);
                    }}
                  />
                );
              }}
            />

            <AnswerLabel key={key} htmlFor={key} stacked={stacked}>
              {label}
            </AnswerLabel>
          </RadioOption>
        );
      })}
      <Field name={name} component={errorMessage} />
    </div>
  );
}

RadioGroup.propTypes = {
  options: PropTypes.array,
  name: PropTypes.string,
  label: PropTypes.string,
  stacked: PropTypes.bool,
  onChange: PropTypes.func
};
